import { isAppPrerendering } from '@zyro-inc/site-modules/utils/prerenderingFlags';
import {
	facebookPixelScript,
	facebookPixelNoScript,
	googleAnalyticsScript,
	googleAnalyticsScriptAsync,
	googleTagManagerScript,
	googleTagManagerNoScript,
	hotjarScript,
	jivoChatScriptAsync,
} from '@/components/metas/integrations/scripts';

export const getIntegrationElements = ({
	siteMeta,
	elementDataAttribute,
}) => {
	if (isAppPrerendering) return [];

	const integrationElements = {};

	if (siteMeta.facebookPixel) {
		integrationElements['noscript-fb-pixel'] = {
			tagName: 'noscript',
			children: [
				{
					type: 'text',
					value: facebookPixelNoScript(siteMeta.facebookPixel),
				},
			],
		};
	}

	if (siteMeta.googleTagManager) {
		integrationElements['noscript-gtm'] = {
			tagName: 'noscript',
			children: [
				{
					type: 'text',
					value: googleTagManagerNoScript(siteMeta.googleTagManager),
				},
			],
		};
	}

	if (siteMeta.facebookPixel) {
		integrationElements['script-fb-pixel'] = {
			tagName: 'script',
			children: [
				{
					type: 'text',
					value: facebookPixelScript(siteMeta.facebookPixel),
				},
			],
		};
	}

	if (siteMeta.googleTagManager) {
		integrationElements['script-gtm'] = {
			tagName: 'script',
			children: [
				{
					type: 'text',
					value: googleTagManagerScript(siteMeta.googleTagManager),
				},
			],
		};
	}

	if (siteMeta.googleAnalytics) {
		integrationElements['script-google-analytics'] = {
			tagName: 'script',
			children: [
				{
					type: 'text',
					value: googleAnalyticsScript(siteMeta.googleAnalytics),
				},
			],
		};

		integrationElements['script-google-analytics-async'] = {
			tagName: 'script',
			properties: {
				src: googleAnalyticsScriptAsync(siteMeta.googleAnalytics),
			},
		};
	}

	if (siteMeta.hotjar) {
		integrationElements['script-hotjar'] = {
			tagName: 'script',
			children: [
				{
					type: 'text',
					value: hotjarScript(siteMeta.hotjar),
				},
			],
		};
	}

	if (siteMeta.jivoChat) {
		integrationElements['script-jivochat'] = {
			tagName: 'script',
			properties: {
				src: jivoChatScriptAsync(siteMeta.jivoChat),
			},
		};
	}

	return Object.entries(integrationElements)
		.map(([
			elementKey,
			{
				tagName,
				properties = {},
				children = [],
			},
		]) => ({
			type: 'element',
			tagName,
			properties: {
				...properties,
				[elementDataAttribute]: elementKey,
			},
			children,
		}));
};
